const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/timhortons/service/',
  children: [
    {
      path: '/reports/timhortons/service/serviceTimes',
      meta: { id: 'reports-thServiceTimes' },
      name: 'Service Times',
      component: () => import('./ServiceTimeStatistics.vue'),
      permissions: ['thServiceTimes'],
    },
  ]
};

export default routes;
